<template>
    <div>
        <hos_apply_title title="患者基本信息"></hos_apply_title>
        <el-form :model="form" class="mt20" label-position="left" :rules="patineInfoRules" ref="patientForm" size="mini">
            <!--<el-row>
                <el-col :span="10">
                    <el-form-item label="患者就诊卡号" label-width="100px">
                        <el-input v-model="cardId" placeholder="请输入就诊卡号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                    <el-form-item label-width="20px">
                        <el-select v-model="cardIdHos" placeholder="请选择就诊卡号所属医院">
                            <el-option :label="hos.yymc" :value="hos.yyid" v-for="(hos,index) in cardIdHosList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4" :push="1">
                    <el-form-item>
                        <el-button type="primary" @click="search">检索</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label-width="80px" label="病人姓名">
                        <el-select v-model="form.consulterName" @change="patChange">
                            <el-option :label="pat.patname" :value="pat.patientid" v-for="(pat,index) in patList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="14" :push="2">
                    <el-form-item label="证件号" label-width="80px" prop="consulterIdcard">
                        <el-input v-model="form.consulterIdcard"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>-->
            <el-row>
                <el-col :span="8">
                    <el-form-item label="证件号" label-width="80px" prop="consulterIdcard">
                        <el-input v-model="form.consulterIdcard"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label-width="20px">
                        <el-select v-model="cardIdHos" placeholder="请选择就诊卡号所属医院">
                            <el-option :label="hos.yymc" :value="hos.yyid" v-for="(hos,index) in cardIdHosList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item label-width="70px" label="病人姓名">
                        <el-select v-model="form.consulterName" @change="patChange">
                            <el-option :label="pat.patname" :value="pat.patientid" v-for="(pat,index) in patList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2" :push="1">
                    <el-form-item>
                        <el-button type="primary" @click="search">检索</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <el-form-item label="性别" label-width="40px">
                        <el-select v-model="form.sex">
                            <el-option label="男" value="M"></el-option>
                            <el-option label="女" value="F"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="年龄" label-width="40px">
                        <el-input v-model="form.age"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="13">
                    <el-form-item label="电话" label-width="60px" prop="consulterMobile">
                        <el-input v-model="form.consulterMobile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="9">
                    <el-form-item label="职业" label-width="40px" prop="consulterJob">
                        <el-input v-model="form.consulterJob"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="13" :push="2">
                    <el-form-item label="其他联系方式" label-width="100px">
                        <el-input v-model="form.otherPhoneNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-form-item label="家庭地址" label-width="80px" prop="province">
                        <el-select v-model="form.province" placeholder="请选择省" @change="getCityList('1')">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in provinceList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item prop="city">
                        <el-select v-model="form.city" placeholder="请选择市" @change="getCityList('2')">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in cityList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="7">
                    <el-form-item>
                        <el-select v-model="form.area" placeholder="请选择区">
                            <el-option :label="pro.areaName" :value="pro.id" v-for="(pro,index) in areaList" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label-width="80px" prop="consulterAddress">
                        <el-input v-model="form.consulterAddress" placeholder="街道等 详细地址 选择填写"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
       <!-- <el-form ref="form" :model="form" label-width="70px" label-position="left" size="mini" :disabled="readonly">
            <el-row>
                <el-col :span="16" class="flex aic" v-if="readonly===false">
                    <span class="fs16 color_main">建议使用身份读卡设备</span>
                    <div class="ml5">
                        <el-input placeholder="请输入身份证信息 / 病历号" size="mini" v-model="key"></el-input>
                    </div>
                    <div class="ml5">
                        <el-button type="primary" size="mini" @click="getBaseForm">查询</el-button>
                        <el-button type="primary" size="mini" @click="getDemoPat">生成测试用户</el-button>
                    </div>
                </el-col>
                <el-col v-if="readonly" :span="readonly?24:8" class="fs20" style="text-align: right">
                    会诊费用：<span class="color_red">￥{{value.consultFee}}</span>
                </el-col>
            </el-row>
            <el-row class="mt20" :gutter="20">
                <el-col :span="7">
                    <el-form-item label="患者姓名">
                        <el-input v-model="form.consulterName" placeholder="身份证读取/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="性别" label-width="40px">
                        <el-select v-model="form.sex" placeholder="性别">
                            <el-option v-for="(d,i) in SEX" :key="i" :label="d" :value="d"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="年龄" label-width="40px">
                        <el-input v-model="form.age" placeholder="年龄"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="患者病历号" label-width="90px">
                        <el-input v-model="form.consulterInhosno" placeholder="自动检索到病历号，可能有多个"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="7">
                    <el-form-item label="身份证">
                        <el-input v-model="form.consulterIdcard" placeholder="身份证读取/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="电话" label-width="40px">
                        <el-input v-model="form.consulterMobile" placeholder="HIS中导入/手工"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label="婚姻" label-width="40px">
                        <el-select v-model="form.maritalStatus" placeholder="婚姻">
                            <el-option v-for="(d,i) in MARITALSTATUS" :key="i" :label="d" :value="i+''"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="职业" label-width="40px">
                        <el-input v-model="form.consulterJob" placeholder="请输入职业"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="家庭住址">
                        <el-cascader :value="areaArr" @change="areaChange" @active-item-change="activeItemChange"
                                     :options="area"
                                     :props="{label:'areaName',value:'id'}"
                                     placeholder="请选择地区"></el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="10">
                    <el-form-item label="" label-width="10px">
                        <el-input v-model="form.consulterAddress" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>-->
    </div>
</template>

<script>
  import {isEmpty,pickByArray} from "../../lib/utils";
  import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../lib/filters";
  import {MARITALSTATUS, SEX} from "../../lib/config";
  import {systemService} from "../../lib/service/system";
  import {getRandomHisPatInfo} from "../../lib/mock";
  import hos_apply_title from "../../components/hos/hos-apply-title"
  import {hosService} from "../../lib/service/hos"
  import {patineInfoRules} from "../../lib/hos/until"

  export default {
    name: "casultation-base-form",
    components: {hos_apply_title},
    props: {
      readonly: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        area: [], areaArr: [],
        key: '',
        MARITALSTATUS, SEX,
        form: {
          age: '',
          sex: '',
          consulterName: '',
          consulterIdcard: '',
          consulterMobile: '',
          consulterJob: '',
          consulterAddress: '',
            otherPhoneNumber:'',
          consulterAreaCode: '',
            province:"",
            city:"",
            area:""
        },
          cardId:"",//患者就诊卡号
          patList: [], //就诊卡号重复的患者列表
          provinceList:[],
          cityList:[],
          areaList:[],
          cardIdHos:'',//就诊卡查询医院
          cardIdHosList:[],
          patineInfoRules,
      }
    },
    async created() {
        await this.queryHosList();
        await this.getAreaList();
        const {meta, query} = this.$route;
        //是否是再次申请
        if(query.again){
            this.setAgainData();//设置缓存数据
            this.getPro();
        }

    },
    watch: {
      value: {
        async handler(newV) {
          this.form = newV;
          const {consulterIdcard, consulterAreaCode} = newV;
          if (consulterIdcard) {
            this.form.sex = getSexFromIdCardFilter(consulterIdcard);
            this.form.age = getAgeFromIdCardFilter(consulterIdcard, '');
          }
          if (consulterAreaCode) {
            let areaArr = await systemService.getAllAreaCode(consulterAreaCode);
            this.resetArea(areaArr);
          }
        }
      }
    },
    methods: {
      getForm() {
          let vail = true;
          this.$refs['patientForm'].validate((valid) => {
              if (!valid) {
                  vail = false
                  return false;
              }
          });
          //判断区域code
          if(this.form.area != ""){
              this.form.consulterAreaCode = this.form.area;
          }else if(this.form.city != ""){
              this.form.consulterAreaCode = this.form.city;
          }else{
              this.form.consulterAreaCode = this.form.province;
          }
          console.log('病人信息表单查询数据：');
          console.log(this.form);
          return {form:this.form,vail:vail};
      },
      async getDemoPat() {
        this.form = await getRandomHisPatInfo();
        let areaArr = await systemService.getAllAreaCode(this.form.consulterAreaCode);
        this.resetArea(areaArr);
      },

      async getBaseForm() {
        /*const {key} = this;
        if (isEmpty(key)) return '';
        if (key.length === 18) {
          this.form.age = getAgeFromIdCardFilter(key, '');
          this.form.sex = getSexFromIdCardFilter(key);
          this.form.consulterIdcard = key;
        }*/
        this.$message.error('无建档记录');
      },
      // async getAreaList() {
      //   const area = await systemService.areaList(null, 1);
      //   this.area = area.map(r => {
      //     return {areaName: r.areaName, id: r.id, children: []};
      //   });
      // },

        //获取地区联动列表
        async getAreaList(){
            const obj = await hosService.getAllArea({});
            for(let i in obj){
                this.provinceList.push(obj[i]);
            }
        },

      async activeItemChange(val) {
        Log('val', val);
        let list = await systemService.areaList([...val].pop(), val.length + 1);
        let arr = this.area, curr = null;
        for (let a of val) {
          curr = arr.find(r => r.id === a);
          arr = curr.children;
        }
        if (list.length > 0) {
          curr.children = list.map(r => {
            return {areaName: r.areaName, id: r.id, children: val.length >= 2 ? undefined : []};
          });
        } else {
          delete curr.children;
        }
      },
      areaChange(val) {
        this.form.consulterAreaCode = [...val].pop();
      },
      async resetArea(areaArr) {
        const {area} = this;
        if (isEmpty(area)) {
          setTimeout(this.resetArea, 200);
        } else {
          let level = 2, currList = this.area;
          while (level <= 3) {
            let arr = await systemService.areaList(areaArr[level - 2], level);
            let currArea = currList.find(r => r.id === areaArr[level - 2]);
            currArea.children = arr;
            currList = arr;
            level++;
          }
          this.areaArr = areaArr;
        }
      },
      //根据患者就诊卡号查询数据
      async search() {
        if (this.form.consulterIdcard == "") return this.$message.error('请输入身份证号。');
        // if(this.cardId == "")return this.$message.error('请输入就诊卡号。');
        // if(this.cardIdHos == "")return this.$message.error('请选择就诊卡号所属医院。');
        /*const {code,list} = await hosService.searchByCard({
            orgid:this.cardIdHos,
            hosPatid:this.cardId,
            type:'1'
        })*/
        const {code, list} = await hosService.searchByCard({
          orgid:this.cardIdHos,
          idcard: this.form.consulterIdcard,
          Idcardtype: '0'
        })
        if (list.length != 0 && code == 0) {
          this.patList = list
          this.form.consulterIdcard = list[0].idcard || '';
          this.form.consulterMobile = list[0].mobileno || '';
          this.form.consulterName = list[0].patname || '';
          this.form.consulterAddress = list[0].address || '';
          this.form.sex = list[0].patsex === '1' ? 'M' : 'F';
          this.form.age = list[0].age
        } else {
          this.$message.error('未查询到相关信息。')
        }
      },

        patChange(val) {
            this.patList.forEach(item => {
                if (item.patientid === val){
                    this.form.consulterIdcard = item.idcard || '';
                    this.form.consulterMobile = item.mobileno || '';
                    this.form.consulterName = item.patname || '';
                    this.form.consulterAddress = item.address || '';
                    this.form.sex = item.patsex==='1'? 'M' :'F';
                    this.form.age = item.age
                }
            })
        },
        //下拉框事件
        getCityList(f){
            const that = this;
            if(f == 1){
                let city =  this.provinceList.find(function(item){
                    return item.id == that.form.province
                })
                this.cityList = city.subSysArea;
                this.form.city = "";
                this.form.area = "";
                this.areaList = [];
            }else{
                let area =  this.cityList.find(function(item){
                    return item.id == that.form.city
                })
                this.areaList = area.subSysArea;
                this.form.area = "";
            }
        },
        setAgainData(){
            const cache = this.$cache.get('consultationOrderCache');
            console.log('cache')
            console.log(cache)
            let consultationOrder = {...pickByArray(cache.consultGroup, ['consulterName','consulterIdcard','consulterMobile','consulterJob','consulterAddress','otherPhoneNumber','consulterAreaCode'])}
            this.form = Object.assign({},this.form,consultationOrder);
            this.form.sex = cache.consultGroup.consulterGender;
            this.form.age = cache.consultGroup.consulterAge;
        },
        getPro(){
          let areaobj, areaList ;
         let areaObj = this.provinceList.forEach((v,i,a)=>{
             if(v.id == this.form.consulterAreaCode) {
                 areaobj = v;
                 areaList = v;
                 return
             }
             if(v.subSysArea){
                 v.subSysArea.forEach((v2)=>{
                     if(v2.id == this.form.consulterAreaCode) {
                         areaobj = v2;
                         areaList = v;
                         return
                     }
                     if(v2.subSysArea){
                         v2.subSysArea.forEach((v3)=>{
                             if(v3.id == this.form.consulterAreaCode) {
                                 areaobj = v3;
                                 areaList = v;
                                 return
                             }
                         })
                     }
                 })
             }
         })
            if(areaobj.areaLevel == '3'){
                this.form.province = areaList.id;
                this.getCityList('1');
                this.form.city = areaobj.superId;
                this.getCityList('2');
                this.form.area = areaobj.id;
            }
            if(areaobj.areaLevel == '2'){
                this.form.province = areaList.id;
                this.getCityList('1');
                this.form.city = areaobj.id;
                this.getCityList('2');
            }
            if(areaobj.areaLevel == '1'){
                this.form.province = areaList.id;
                this.getCityList('1');
            }
        },
        async queryHosList(){
            const {code, list=[]} = await this.$http('smarthos.yygh.ApiPlatBaseService.areaHosList')
            this.cardIdHosList = list;
        }
    },
  }
</script>

<style scoped lang="scss">

</style>
